import Axios from 'axios'
import { api } from '../../../services/api'

export async function getInfoPayment(data) {
  const response = await api.get(`/site/v2/editar-pedido/busca-informacoes-itens/${data}`)

  const responseFormatted = response.data.map((item) => {
    return {
      ...item,
      QTDNEG: new Intl.NumberFormat('pt-BR', item.QTDNEG).format(item.QTDNEG),
      VALOR_UNIT: parseFloat(item.VALOR_UNIT).toFixed(2),
    }
  })

  return responseFormatted
}

export async function getInfoPartner(data) {
  const response = await api.get(`/site/v2/pedido/busca-info-clientes-pagamento/${data}`)

  return response.data
}

export async function updateEnterprises(codEmp, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-empresas', {
      codigo_empresa: codEmp,
      numero_nota: nunota,
    })

    console.log('parametros', codEmp, nunota)
    console.log('Empresa: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function updateConsultor(codVend, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-consultor', {
      codigo_vendedor: codVend,
      numero_nota: nunota,
    })

    console.log('Consultor: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoFaturamento(codparc, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-faturamento', {
      codigo_parceiro: codparc,
      numero_nota: nunota,
    })

    console.log('Faturamento: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoEntrega(codparc_dest, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-entrega', {
      codparc_dest: codparc_dest,
      numero_nota: nunota,
    })

    console.log('Entrega: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoDtSaida(dt_saida, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-dtsaida', {
      dt_saida: dt_saida,
      numero_nota: nunota,
    })

    console.log('Data Saida: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoTransportadora(codigo_transportadora, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-transportadora', {
      codigo_transportadora: codigo_transportadora,
      numero_nota: nunota,
    })

    console.log('Transportadora: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoDataSaida(data, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-data-saida', {
      data: data,
      numero_nota: nunota,
    })

    console.log('Transportadora: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoProduct(codigo_produto, nunota, sequencia, cor) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-produto', {
      codigo_produto: codigo_produto,
      numero_nota: nunota,
      sequencia: sequencia,
      cor: cor,
    })
  } catch (error) {
    console.log(error)
  }
}
export async function editInfoProductColor(cor, item) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-produto-cor', {
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
      cor: cor,
    })
  } catch (error) {
    console.log(error)
  }
}
export async function editInfoGravacao(gravacao, item) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-gravacao', {
      gravacao: gravacao,
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
    })
  } catch (error) {
    console.log(error)
  }
}
export async function editInfoBatidas(qtdbatida, item) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-quantidade-batidas', {
      qtdbatida: qtdbatida,
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
    })
  } catch (error) {
    console.log(error)
  }
}
export async function editInfoPrazoEntrega(prazo, item) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-prazo-entrega', {
      prazo: prazo,
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
    })
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoQuantidadeProduct(valorUnitario, quantidade, valorTotal, item, codusu) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-quantidade-produto', {
      valor: valorUnitario,
      valor_total: valorTotal,
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
      quantidade: quantidade,
      usuario: codusu,
    })

    console.log('Quantidade: ', response)
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoValorUnitario(valorUnitario, valorTotal, item) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-valor-unitario', {
      valor: valorUnitario,
      valor_total: valorTotal,
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
    })
  } catch (error) {
    console.log(error)
  }
}

export async function editInfoDestacaFrete(valor, nunota) {
  const response = await api.put('/site/v2/editar-pedido/editar-destaca-frete', {
    vlr_frete: valor,
    numero_nota: nunota,
  })

  return response.data
}

export async function editPrecoBase(valor, item) {
  const response = await api.put('/site/v2/editar-pedido/editar-preco-base', {
    preco_base: valor,
    numero_nota: item.NUNOTA,
    sequencia: item.SEQUENCIA,
    codigo_produto: item.CODPROD,
  })

  return response.data
}

export async function editInfoValorFrete(valor, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-valor-frete', {
      valor: valor,
      numero_nota: nunota,
    })
  } catch (error) {
    console.log(error)
  }
}
export async function editInfoTipoFrete(tipo_frete, nunota) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-tipo-frete', {
      tipo_frete: tipo_frete,
      numero_nota: nunota,
    })
  } catch (error) {
    console.log(error)
  }
}
export async function editInfoLinkLayout(link, nunota, sequencia) {
  try {
    const response = await api.post('/site/v2/editar-pedido/editar-info-link-layout', {
      link: link,
      numero_nota: nunota,
      sequencia: sequencia,
    })
  } catch (error) {
    console.log(error)
  }
}

export async function listarVendedores() {
  try {
    const response = await api.get('/site/v2/editar-pedido/listar-vendedores')
    console.log(response)
    return response.data
  } catch (error) {
    console.log(error)
  }
}
export async function listarEmpresas() {
  try {
    const response = await api.get('/site/v2/pedido/lista-empresas')

    return response.data
  } catch (error) {
    console.log(error)
  }
}
export async function listarCoresDisponiveis(codprod) {
  try {
    const response = await api.get(`/site/v2/produto/${codprod}/cores-disponiveis`)

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export async function excludeItem(item, codusu) {
  const params = {
    numero_nota: item.NUNOTA,
    sequencia: item.SEQUENCIA,
    codigo_produto: item.CODPROD,
    usuario: codusu,
  }

  console.log('params, ', params)

  const response = await api.post('/site/v2/editar-pedido/excluir-info-produto', params)

  console.log(response)
}
